import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import { FETCH_SERVICE_RESERVATIONS } from '../queries/serviceReservation';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const fetchServiceReservations = async (where = {}, limit = 100) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: { where, limit },
      query: FETCH_SERVICE_RESERVATIONS,
    });
    return await unmarshalGraphqlResponse(response.data, 'service_reservations')
      .edges;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
